import React from 'react';
import styles from './Footer.module.css';

const Footer: React.FC = () => (
  <footer className={styles.footer}>
    Dylo Inc Dashboard ©2026 Created by Dylo Devs
  </footer>
);

export default Footer;
